import type { RouteLocationRaw } from 'vue-router';

import { getClientAutoLaunchAppId } from './orchestrator';
import { resolveLastAccessibleHubAppId } from './lastHubApp';

/**
 * Default post-auth / cold-entry destination when push/share intents are absent.
 * Priority: single-app client auto-launch, then last accessible hub app.
 */
export async function resolveDefaultHubAppDestination(
	accessToken: string | undefined,
): Promise<RouteLocationRaw | undefined> {
	const clientAppId = getClientAutoLaunchAppId(accessToken);
	if (clientAppId) {
		return { name: 'app-shell', params: { appId: clientAppId } };
	}

	const lastAppId = await resolveLastAccessibleHubAppId(accessToken);
	if (lastAppId) {
		return { name: 'app-shell', params: { appId: lastAppId } };
	}

	return undefined;
}

/**
 * True when navigating to the welcome/launcher from another authenticated hub
 * surface (e.g. Switch Apps). Those visits must not bounce back to last app.
 */
export function isReturningToWelcomeFromHub(
	fromName: string | symbol | null | undefined,
): boolean {
	return fromName === 'app-shell';
}
